import { gql } from '@apollo/client'

export const UPSERT_DEXCOM_CONNECTION = gql`
  mutation upsertDexcomConnection(
    $authorizationCode: String!
    $dexcomConnectionKind: DexcomConnectionKind!
    $sensorModel: DexcomConnectionSensorModel
  ) {
    upsertDexcomConnection(
      authorizationCode: $authorizationCode
      dexcomConnectionKind: $dexcomConnectionKind
      sensorModel: $sensorModel
    ) {
      status
      lastSyncedAt
      kind
    }
  }
`
